import axiosJson from '@/http/config/axiosJson'

export const queryMenu = (data) => axiosJson({
  loading: 'silent',
  url: '/sys/resource/queryMenu',
  method: 'post',
  data,
})
